import { render, staticRenderFns } from "./Updates.vue?vue&type=template&id=5c69b434"
import script from "./Updates.vue?vue&type=script&lang=js"
export * from "./Updates.vue?vue&type=script&lang=js"
import style0 from "./Updates.vue?vue&type=style&index=0&id=5c69b434&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports